//////////////////
// IMPORTS
//////////////////
// libraries
import React from "react";

// util
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
import { m365InterestFormUrl } from "@clockwise/client-commons/src/constants/site";

export const M365WaitlistLink = () => {
  const onClickM365 = () => {
    track(TrackingEvents.AUTH.M365_WAITLIST_CLICKED);
  };

  return (
    <div className="cw-flex cw-items-center cw-justify-center cw-font-body cw-text-[15px] cw-text-slate-standard cw-leading-7 cw-mt-2 cw-mb-5">
      <div>
        Use Microsoft 365?{" "}
        <a
          className="cw-text-slate-standard"
          href={m365InterestFormUrl}
          target="_blank"
          onClick={onClickM365}
          rel="noreferrer"
        >
          Sign up for our waitlist
        </a>
      </div>
    </div>
  );
};
